import { Avatar, Box, Flex } from '@chakra-ui/core'
import { RootState } from 'constants/interfaces'
import useAvatar from 'hooks/useAvatar'
import React from 'react'
import { useSelector } from 'react-redux'
import LocaleText from 'components/LocaleText'
import keys from 'constants/keys'
import colors from 'constants/colors'
import { Camera } from 'lucide-react'
import { isRtlSelector } from 'redux/selectors/general'

export const UserDetails = () => {
  const { myUID, first_name, last_name, user_role } = useSelector((state: RootState) => state.config.config)
  const isRtl = useSelector(isRtlSelector)

  const avatar = useAvatar(myUID)
  const fullName = `${first_name} ${last_name ? last_name : ''}`
  const roleKey = String(user_role) as unknown as keyof typeof keys.USER_ROLES

  return (
    <Flex p="20px">
      <>
        <Box cursor={'pointer'} pos="relative">
          <Avatar src={avatar} width="60px" height="60px" />
          <Box
            pos="absolute"
            bottom="-10px"
            right={isRtl ? 'unset' : '-10px'}
            left={isRtl ? '-10px' : 'unset'}
            bg="white"
            borderRadius="50%"
            p="5px"
          >
            <Camera />
          </Box>
        </Box>
      </>

      <Box mx="10px">
        <Box fontSize="18px" fontWeight="600">
          {fullName}
        </Box>
        <Box fontSize="13px" color={colors.greyMain}>
          <LocaleText text={keys.USER_ROLES[roleKey]} />
        </Box>
      </Box>
    </Flex>
  )
}
